import React, { Component } from 'react';
import RequestManager from '../../requests/RequestManager';
import followersTask from '../../requests/tasks/social/followers/followersTask';
import followTask from '../../requests/tasks/social/follow/followTask';
import unfollowTask from '../../requests/tasks/social/unfollow/unfollowTask';
import SocialUserCard from '../../components/Social/SocialUserCard';
import { showModal, MODAL_GENERIC, AAF_MODAL_ERROR } from '../../actions/modal';
import Pagination from '../../components/Social/Pagination';
import Social from '../../utils/social/Social';
import Translator from "../../requests/apa/Translator";
import { connect } from 'react-redux';


class Socialfollowers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            followers: [],
            skip: 0,
            limit: 15,
            page: 1,
            num: 15,
        }
    }

    getData = (e, d) => {
        e.preventDefault();
        let page = d.limit / this.state.num;;

        let parameters = [{
            skip: d.skip,
            limit: d.limit,
            gameId: this.props.gameId,
        }, this.props.gamificationId ];

        let params = new followersTask(...parameters);
        RequestManager.addRequest(params)
        .then((data) => {
            if(data.data) {
                this.setState({
                  followings: data.data,
                  skip: parameters[0].skip,
                  limit: parameters[0].limit,
                  page,
                }, () => { window.SpatialNavigation.focus('.followers .focusable') })
            }

        })
        .catch((e) => {
            const modal = {
                modalType: AAF_MODAL_ERROR,
                modalProps: {
                    content: e,
                }
            }
            this.props.showModal(modal);
        })

    }

    getTask = (p, task) => {
        const tasks = {
            follow: () => { return new followTask(p) },
            unfollow: () => { return new unfollowTask(p) }
        }

        return tasks[task]();
    }

    warningModal = () => {
        const buttons = [{
            content: Translator.get('btn_modal_ok','Aceptar'),
            props: {},
        }]

        const newModal = {
          modalType: MODAL_GENERIC,
          modalProps: {
            title: Translator.get('social_title_ups', 'Ops!'),
            content: Translator.get(
                'social_modal_anonymous',
                'Para poder seguir usuarios necesitas iniciar sesión o registrarte'
            ),
            buttons,
            buttonsAlign: 'vertical'
          }
        };

        this.props.showModal(newModal);
    }

    executeChuck = (card, task) => {
        let p = Social.buildParams(this.props.gamificationIdUserlogged, card);
        let params = this.getTask(p, task);
        const request = RequestManager.addRequest(params);

        request
            .then(data => this.success(card, task))
            .catch((e) => this.error(e));
    }

    error = (e) => {
        const modal = {
            modalType: AAF_MODAL_ERROR,
            modalProps: {
                content: e,
            }
        }

        this.props.showModal(modal);
    }

    success = (card, task) => {
        const followers = Object.assign([], this.state.followers);
        const newFollowers = Social.parseFollowers(followers, card, task);
        const dispatch = Social.getDispatch(task);

        this.props[dispatch](card.id);
        this.setState({ followers: newFollowers });

    }

    follow = (event, card) => {
        const action = !Social.isAnonymous(this.props.user) ? 'executeChuck' : 'warningModal';
        this[action](card, 'follow');
    }

    unfollow = (event, card) => {
        const action = !Social.isAnonymous(this.props.user) ? 'executeChuck' : 'warningModal';
        this[action](card, 'unfollow');
    }

    componentDidMount() {
        window.SpatialNavigation.makeFocusable()

        let p = {
            skip: this.state.skip,
            limit: this.state.limit,
            gameId: this.props.gameId,
        }

        let params = new followersTask( p, this.props.gamificationId);
        RequestManager.addRequest(params)
        .then((data) => {
            if(data.data)
                this.setState({ followers: data.data })
        })
        .catch((e) => {
            const modal = {
                modalType: AAF_MODAL_ERROR,
                modalProps: {
                    content: e,
                }
            }
            this.props.showModal(modal);
        })

    }

    parseFollowings = (ownfollowings, otherFollowers) => {
        if(Array.isArray(ownfollowings) && Array.isArray(otherFollowers)) {
            ownfollowings.map((it) => {
                otherFollowers.map((__it) => {
                    if(it.id === __it.id) {
                        __it.following = true;
                    }
                })
            })
        }
    }

    render() {
        if (this.state.followers.length === 0) {
          const owner = this.props.isCurrentUser ? 'own' : 'other' ;
          return (
            <div className="followers-empty" style={{ fontSize: 18 }}>
              { Translator.get(`${owner}_social_profile_empty_followers_msg`) }
            </div>
          )
        }

        const followers = Object.assign([], this.state.followers);

        this.parseFollowings(this.props.ownFollowings, followers);

        const followingsComponent = followers.map((it, i) => {
            const callToAction = it.following ? this.unfollow : this.follow;
            if(this.props.user.isAnonymous) { it.following = false; }
            const ga = Social.filterGamesArray(this.props.gameId, it.gamesArray);

            if(it.config.isPrivate == false && it.id !== this.props.gamificationIdUserlogged) {
                if(it.gamesArray && ga) {
                    return (<SocialUserCard
                        key={i}
                        card={it}
                        following={ it.following ? it.following: false }
                        callToAction={callToAction}
                        gameId={this.props.gameId}
                        gamesArray={ga}
                        translations={this.props.translations}
                    />)
                }
                else return null;
            }
        })

        return(<div className="followers">
            { followingsComponent }
            <Pagination
                skip={this.state.skip}
                limit={this.state.limit}
                page={this.state.page}
                activities={followers}
                num={this.state.num}
                getData={this.getData}
                translations={this.props.translations}
            />
        </div>);
    }

}

export default connect(null, { showModal })(Socialfollowers);



// WEBPACK FOOTER //
// ./src/containers/Social/SocialFollowers.jsx